import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PageWrapper = (props) => {
  useEffect(() => {
    const handleDocClick = (e) => {
      const collapse = document.getElementById("navbarResponsive");
      const toggler = document.querySelector(".navbar-toggler");
      if (!collapse || !toggler) return;

      const isOpen = collapse.classList.contains("show");
      const target = e.target;

      // if open and click is outside collapse and not on toggler, close it
      if (
        isOpen &&
        !collapse.contains(target) &&
        !toggler.contains(target)
      ) {
        collapse.classList.remove("show");
        // update aria-expanded on toggler for accessibility
        try {
          toggler.setAttribute("aria-expanded", "false");
        } catch (err) { }
      }
    };

    document.addEventListener("click", handleDocClick);

    // close menu on scroll
    const handleScrollClose = () => {
      const collapse = document.getElementById("navbarResponsive");
      const toggler = document.querySelector(".navbar-toggler");
      if (!collapse || !toggler) return;
      if (collapse.classList.contains("show")) {
        collapse.classList.remove("show");
        try {
          toggler.setAttribute("aria-expanded", "false");
        } catch (err) { }
      }
    };

    window.addEventListener("scroll", handleScrollClose, { passive: true });

    return () => {
      document.removeEventListener("click", handleDocClick);
      window.removeEventListener("scroll", handleScrollClose);
    };
  }, []);

  const closeMenuAndScroll = () => {
    const collapse = document.getElementById("navbarResponsive");
    const toggler = document.querySelector(".navbar-toggler");
    if (collapse && collapse.classList.contains("show")) {
      collapse.classList.remove("show");
      try {
        toggler.setAttribute("aria-expanded", "false");
      } catch (err) { }
    }
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <div>
      <nav
        className="navbar navbar-expand-lg navbar-dark fixed-top"
        id="mainNav"
      >
        <div className="container">
          <Link className="navbar-brand js-scroll-trigger" to="/">
            <img
              src="./assets/image/test1.svg"
              alt="loading..."
            />
          </Link>
          <Link
            className="navbar-home-mobile d-none d-lg-none"
            to="/"
            onClick={closeMenuAndScroll}
            aria-label="Home"
            title="Home"
          >
            <i className="fas fa-home"></i>
          </Link>
          <button
            className="navbar-toggler navbar-toggler-right"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            Menu<i className="fas fa-bars ml-1"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav text-uppercase ml-auto">
              <li className="nav-item">
                <Link className="nav-link js-scroll-trigger" to="/" onClick={closeMenuAndScroll}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link js-scroll-trigger" to="/services" onClick={closeMenuAndScroll}>
                  How it works
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link js-scroll-trigger" to="/portfolio" onClick={closeMenuAndScroll}>
                  Portfolio
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link js-scroll-trigger" to="/colours" onClick={closeMenuAndScroll}>
                  Colours
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link js-scroll-trigger" to="/contact" onClick={closeMenuAndScroll}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <main id="page-content">
        {props.children}
      </main>
    </div>
  );
}

export default PageWrapper;
